import { getRequest, postRequest, putRequest } from "../../config/axiosConfig";

export const createRole = async ({ name, prefix, description }) => {
  const payload = {
    role_description: description,
    role_name: name,
    prefix,
  };
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "roles/create-role",
      data: payload,
    });

    if (response?.status === 201) {
      return {
        success: true,
        data: response,
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid create role request.",
    };
  }
};

export const getAllRoles = async () => {
  try {
    const response = await getRequest({
      url: process.env.REACT_APP_BASE_URL + "roles/get-all-role",
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid roles retrival request.",
    };
  }
};
export const getRolesById = async ({ role_id }) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "roles/get-role-by-id",
      data: { role_id },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid roles retrival request.",
    };
  }
};

export const grantRolePermission = async ({ id, dashboard, system }) => {
  const payload = {
    id,
    dashboard,
    system,
  };

  try {
    const res = await putRequest({
      url:
        process.env.REACT_APP_BASE_URL +
        "roles-permission/grant-role-permission",
      data: payload,
    });

    if (res?.status === 200) {
      return {
        success: true,
        data: res,
      };
    } else {
      return {
        success: false,
        data: res,
      };
    }
  } catch (error) {
    console.log(error);
    return {
      success: false,
      data: null,
      message: "Invalid role grant permission request.",
    };
  }
};

export const getRolePermissionById = async ({ role_id }) => {
  try {
    const response = await postRequest({
      url:
        process.env.REACT_APP_BASE_URL +
        "roles-permission/get-role-permission-by-id",
      data: { role_id: role_id },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid roles retrival request.",
    };
  }
};

export const getAllPermissions = async () => {
  try {
    const response = await getRequest({
      url:
        process.env.REACT_APP_BASE_URL +
        "roles-permission/get-all-role-permission",
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid roles retrival request.",
    };
  }
};
